export const ENV = {
  API_URL:
    import.meta.env.DEV &&
    (import.meta.env.VITE_API_URL as string | undefined)?.startsWith("http://localhost")
      ? "/api"
      : (import.meta.env.VITE_API_URL as string),
  STREAM_API_KEY: import.meta.env.VITE_STREAM_API_KEY as string,
} as const;
